// start:ng42.barrel
import   './team-notes.service';
import   './teams.service';
import   './components';
import   './directives';
// end:ng42.barrel

